module.exports = __webpack_public_path__ + "3ab4daf2e3e12d16048447633ef30891.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/gamers-paradise.png
// module id = 2822
// module chunks = 0